const enumTherapistsType = {
  examer: 'בודק',
  nutritionist: 'תזונאי',
  coach: 'מאמן בריאות',
  doctor: 'רופא'
};

export default enumTherapistsType;
